export default __webpack_public_path__ + "static/media/hiw-infinity-new.44125750.png";